import type { ReactElement } from "react";
import loadingMark from "../../assets/loading.svg";

export type SpinnerProps = {
  /** Accessible name for the loading indicator (no visible label). */
  accessibilityLabel?: string;
  className?: string;
};

/**
 * Loading indicator — renders the animated three-dot mark from
 * `src/assets/loading.svg`. `role="status"` + `alt` expose it to assistive tech.
 */
export function Spinner({
  accessibilityLabel = "Loading",
  className
}: SpinnerProps): ReactElement {
  return (
    <img
      src={loadingMark}
      alt={accessibilityLabel}
      role="status"
      className={["fg-spinner", className].filter(Boolean).join(" ")}
    />
  );
}
